var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "garden:exit-stroke-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 5H12C12.6 5 13 5.4 13 6V8M5 19H12C12.6 19 13 18.6 13 18V16M22 12H10M19 8L22.2 11.2C22.6 11.6 22.6 12.2 22.2 12.6L19 16M1 4.8L5 1V23L1 19.2V4.8Z",
    stroke: "#F75656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitStroke);
export default __webpack_public_path__ + "static/media/exit-stroke.67bb691c94f9537d1759d762e86bd320.svg";
export { ForwardRef as ReactComponent };